<table class="table ssr">
    <tbody>
    <ng-container *ngIf="!openedForm">
        <ng-container *ngFor="let key of ssrList | keys">
            <ng-container *ngFor="let ssrkey of ssrList[key] | keys ; let f = first">
                <tr *ngIf="f" [class.notop]="key==='meal'" class="lines">
                    <td [attr.colspan]="getColwidth()" *ngIf="key=='luggage' &amp;&amp; f"
                        (click)="speqVisible = !speqVisible" class="nopadding ">
                        <div class="section-header">
                            <div>
                                {{wording.sportSsr}}
                            </div>
                            <div>
                                <btn type="invisible" classList="no-spacing">
                                    <span class="icon">
                                        <fa-icon [icon]="speqVisible ? iconEyeSlash : iconEye"></fa-icon>
                                    </span>
                                </btn>
                            </div>
                        </div>

                    </td>
                    <td [attr.colspan]="getColwidth()" *ngIf="key=='meal' &amp;&amp; f"
                        (click)="mealVisible = !mealVisible" class="nopadding">
                        <div class="section-header">
                            <div>
                                {{Yii.t('wui-iqba-js', 'Repas')}}
                            </div>
                            <div>
                                <btn type="invisible" classList="no-spacing">
                                    <span class="icon">
                                        <fa-icon [icon]="mealVisible ? iconEyeSlash : iconEye"></fa-icon>
                                    </span>
                                </btn>
                            </div>
                        </div>
                    </td>

                </tr>

                <tr *ngIf="(f &amp;&amp; (speqVisible &amp;&amp; key === 'luggage')) || (f &amp;&amp; (mealVisible &amp;&amp; key === 'meal'))">
                    <th class="ssricon">
                        &nbsp;
                    </th>
                    <th class="travellertd" *ngFor="let travellerItem of traveller | values; let i = index">
                        <div *ngIf="!travellerItem.firstName || !travellerItem.lastName">
                            {{Yii.t('wui-iqba-js', 'Voyageur')}} {{i + 1}}
                        </div>
                        <div *ngIf="travellerItem.firstName &amp;&amp; travellerItem.lastName">
                            {{travellerItem.lastName}} {{travellerItem.firstName}}
                        </div>
                    </th>
                </tr>

                <tr [class.hidden]="(!speqVisible &amp;&amp; key === 'luggage') || (!mealVisible &amp;&amp; key === 'meal')">

                    <th class="ssrth">
                        <div [class.truncate]="(traveller | keys).length > 6">
                            {{ removeStart(ssrList[key][ssrkey].label[language]) }}
                        </div>
                    </th>

                    <td class="travellertd"
                        *ngFor="let travellerItem of traveller | keys ; let i = index"
                        [ngClass]="key">
                        <fa-icon [icon]="iconPlus" class="plusicon"
                                 (click)="addSSR(travellerItem, ssrkey, key)"
                                 *ngIf="!SSRAdded[travellerItem + ssrkey] &amp;&amp; !isImported(travellerItem, ssrkey, key)"></fa-icon>

                        <fa-icon [icon]="iconCheck" class="checkicon"
                                 *ngIf="SSRAdded[travellerItem + ssrkey] || isImported(travellerItem, ssrkey, key)"></fa-icon>

                        <fa-icon [icon]="iconTimes" class="removeicon"
                                 (click)="removeSSR(travellerItem, ssrkey)"
                                 *ngIf="SSRAdded[travellerItem + ssrkey]"></fa-icon>

                        <fa-icon [icon]="iconPen" class="plusicon"
                                 *ngIf="SSRAdded[travellerItem + ssrkey]  &amp;&amp; key != 'meal'"
                                 (click)="openForm(travellerItem, key, ssrkey)"></fa-icon>
                    </td>
                </tr>
            </ng-container>
        </ng-container>
    </ng-container>

    <tr *ngIf="openedForm &amp;&amp; SSRAdded[openedForm.propertyId]">
        <td colspan="2" class="ssr-form-container">
            <h3>{{ ssrList[openedForm.key][openedForm.ssrkey].label[language] }}
                <span *ngIf="traveller[openedForm.travellerItem].lastName || traveller[openedForm.travellerItem].firstName"
                      class="ssr-name">- {{ traveller[openedForm.travellerItem].lastName }} {{ traveller[openedForm.travellerItem].firstName }}</span>
            </h3>
            <form class="ssr-form"
                  (ngSubmit)="closeForm()">
                <div class="fields">
                    <ng-container *ngFor="let fieldkey of ssrList[openedForm.key][openedForm.ssrkey].text.field | keys">
                        <div *ngIf="fieldkey !== 'comment'"
                             class="field {{ssrList[openedForm.key][openedForm.ssrkey].text.field[fieldkey].type}}">
                            <label>{{ ssrList[openedForm.key][openedForm.ssrkey].text.field[fieldkey].label[language] }}
                                <ng-container *ngIf="fieldkey != 'comment'">({{
                                    ssrList[openedForm.key][openedForm.ssrkey].text.field[fieldkey].unit }})
                                </ng-container>
                            </label>

                            <div class="number-field">
                                <div class="field">
                                    <input [(ngModel)]="formValues[openedForm.travellerItem][openedForm.ssrkey][fieldkey]"
                                           [type]="ssrList[openedForm.key][openedForm.ssrkey].text.field[fieldkey].type"
                                           [name]="fieldkey"
                                           [class]="fieldkey"
                                           min="0"
                                           (keypress)="onlyNumberKey($event)">
                                    <div class="spinner-button increase"
                                         (click)="increase(openedForm.travellerItem, openedForm.ssrkey, fieldkey)">
                                            <fa-icon [icon]="iconPlus"></fa-icon>
                                    </div>
                                    <div class="spinner-button decrease"
                                         (click)="decrease(openedForm.travellerItem, openedForm.ssrkey, fieldkey) ">
                                        <fa-icon [icon]="iconMinus"></fa-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <label>{{ ssrList[openedForm.key][openedForm.ssrkey].text.field['comment'].label[language] }}</label>

                <textarea [(ngModel)]="formValues[openedForm.travellerItem][openedForm.ssrkey]['comment']"
                          name="comment"></textarea>

                <btnForm styleType="actionPrincipal"
                         formType="submit">{{Yii.t('wui-iqba-js', 'Enregistrer')}}
                </btnForm>
            </form>
        </td>
    </tr>
    </tbody>
</table>
